import { Box, CircularProgress } from '@mui/material'
import type { PropsWithChildren } from 'react'

type Props = {
  loading: boolean
} & PropsWithChildren

export const LoadingContainer = (props: Props) => {
  if (props.loading) {
    return (
      <Box position="relative">
        <LoadingContainerInner />
        {props.children}
      </Box>
    )
  } else {
    return props.children
  }
}

const LoadingContainerInner = () => (
  <Box
    position="absolute"
    top={0}
    left={0}
    right={0}
    bottom={0}
    height="100%"
    width="100%"
    bgcolor={'#ffffff99'}
    zIndex={2}
    display={'flex'}
  >
    <Box margin="auto" zIndex={3}>
      <CircularProgress />
    </Box>
  </Box>
)
